import { Button, Grid, Menu, Layout, Paper, Table, Alert, ButtonGroup, Loader } from "../../components";
import useSWR from 'swr'
import API from "../../API";
import moment from "moment";
import { COMPANY_OPTIONS } from "../../constants";
import currency from 'currency.js'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useAPI, useAxios } from '../../hooks'
import { useContext } from "react";
import AuthContext from "../../context/auth";
import { Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getBidStatusColor, getBidStatusLabel, getOrderConfirmationColor, getOrderConfirmationLabel, getPaymentStatusColor, getPaymentStatusLabel } from "../../utils";
import {useSnackbar, enqueueSnackbar} from 'notistack'
import { AxiosError } from "axios";

export function Orders () {
    const navigate = useNavigate()

    const [orders, refetchOrders] = useAxios(`/order`)
    const [api, callAPI] = useAxios({}, {manual: true})
    
    return (
        <Layout>
            <Grid container justifyContent="center" minHeight={"calc(100vh - 64px)"} padding={3} >
                {api.loading || orders.loading ? (
                    <div style={{
                        display: 'flex',
                        flex: '1',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Loader />
                    </div>
                ) : (<Grid item xs={12} sm={10}>
                    <Paper elevation={1}>
                    <Table 
                        columns={[
                            { field: 'id', headerName: 'ID', width: 50 },
                            { field: 'created_at', headerName: 'Data', flex: 1, valueFormatter: ({value}) => {
                                return moment(value).format('DD/MM/YYYY HH:mm:ss')
                            } },
                            { field: 'reservation_code', headerName: 'Localizador', width: 120 },
                            { field: 'supplier_name', headerName: 'Fornecedor', flex: 1 },
                            { field: 'airline', headerName: 'Companhia', flex: 1 },
                            { field: 'miles', headerName: 'Quantidade', width: 120, valueFormatter: ({value }) => {
                                return Number(value).toLocaleString('pt-BR')
                            }},
                            { field: 'pax', headerName: 'Passageiros', width: 120 },
                            {
                                field: 'payment.status', headerName: 'Pagamento', flex: 1, 
                                valueGetter: ({row}) => {
                                    return getPaymentStatusLabel(row.payment.status)
                                },
                                renderCell: ({ formattedValue, row }) => {
                                    return (
                                        <Chip color={getPaymentStatusColor(row.payment.status)} label={formattedValue} />
                                    )
                                }
                            },
                            {
                                field: 'confirmation', headerName: 'Status (48h)', flex: 1, 
                                valueGetter: ({value}) => {
                                    return getOrderConfirmationLabel(value)
                                },
                                renderCell: ({ formattedValue, row }) => {
                                    return (
                                        <Chip color={getOrderConfirmationColor(row)} label={formattedValue} />
                                    )
                                }
                            },
                            {
                                field: 'actions', headerName: '', sortable: false, filterable: false, disableColumnMenu: true, renderCell: ({row}) => {
                                    const menuOptions = [
                                    { 
                                        label: 'Editar', 
                                        onClick: async () => {
                                            navigate(`/emissoes/${row.id}`)
                                        }
                                    },
                                    ]

                                    if ((row.confirmation === 'CONFIRMED' || row.confirmation === 'PENDING') && row.payment.status !== 'PAID') {
                                        menuOptions.push({ 
                                            label: 'Cancelar', 
                                            onClick: async () => {
                                                await callAPI({
                                                    url: `/order/${row.id}/cancel`,
                                                    method: 'POST'
                                                })
                                                refetchOrders()
                                            }
                                        })
                                    }

                                    if ((row.confirmation === 'CANCELLED' || row.confirmation === 'PENDING') && row.payment.status !== 'PAID') {
                                        menuOptions.push({ 
                                            label: 'Confirmar', 
                                            onClick: async () => {
                                                await callAPI({
                                                    url: `/order/${row.id}/confirm`,
                                                    method: 'POST'
                                                })
                                                refetchOrders()
                                            }
                                        })
                                    }

                                    if (row.bid.status !== 'DONE' && row.payment.status !== 'PAID') {
                                        menuOptions.push({ 
                                            label: 'Excluir', 
                                            onClick: async () => {
                                                await callAPI({
                                                    url: `/order/${row.id}`,
                                                    method: 'DELETE'
                                                })
                                                refetchOrders()
                                            }
                                        })
                                    }
                                    
                                    return (
                                        <ButtonGroup>
                                            <Menu
                                                options={menuOptions}
                                            >
                                                <MoreHorizIcon />
                                            </Menu>
                                        </ButtonGroup>
                                    )
                                }
                            }
                        ]}
                        rows={(orders?.data || []).map((item: { bid: { user: { name: string }}}) => ({
                            ...item,
                            supplier_name: item.bid.user.name,
                        }))}
                    />
                    </Paper>
                </Grid>)}
            </Grid>
        </Layout>
    )
}